import Auth from '../../modules/Authentication'
import { handleErrors, handleResponse } from '../../modules/Utils'
import { apiUrl } from '../../variables/index'

const headers = {}

export default class Deposits {
  auth = new Auth()
  list = () => {
    const select = '*'
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}deposits/?select=${select}`, { headers }).then(handleErrors).then(handleResponse)
  }
}
